/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Partner_Manage_Storage_Upgrade_TitleInputs */



/**
* | output |
* | --- |
* | "Add {label} storage?" |
*
* @param {Partner_Manage_Storage_Upgrade_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_upgrade_title = /** @type {((inputs: Partner_Manage_Storage_Upgrade_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Upgrade_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.label} Speicher hinzufügen?`)
	return /** @type {LocalizedString} */ (`Add ${i?.label} storage?`)
});